import React from "react";
import { ReportReviewersComponent } from "./ReportReviewers.Component";
import { httpServices } from "../../../services/httpServices";
import { CustomProgressBar } from "../../common/CustomProgressBar";
import MixpanelManager from "../../../services/Analytics";

export class ReportReviewersContainer extends React.Component {
  	constructor(props) {
		super(props);
		this.state = {
			permission: false,
			showLoader: true,
			title: "Report Reviewers",
			reportReviewers: [],
			usersList: [],
			reports: [],
			selectedReport: "",
			editPermission: false,
			dataLoaded: false,
			popUpOpen: false,
			popUpAction: "",
			confirmationMessage: "",
			userId: 0,
			projectLocations: [],
			formValues: {},
			errors: {},
			snackbarOpen : false,
			snackbarVariant : 'success',
			snackbarMsg : '',
			disableButton: false
		};
    	this.deleteReportReviewer = this.deleteReportReviewer.bind(this);
		this.addReportReviewer = this.addReportReviewer.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onConfirm = this.onConfirm.bind(this);
		this.onAdd = this.onAdd.bind(this);
		this.handleOnChange = this.handleOnChange.bind(this);
		this.MixpanelManager = new MixpanelManager();				
  	}

	componentDidMount() {
		this.getReportReviewers(this.props.ProjectId);
	}

	getReportReviewers = (projectId) => {
		let apiEndpoint = "api/project/getReportReviewers";
		return httpServices
			.post(apiEndpoint, { project_id: projectId })
			.then((response) => {
				if (response.data) {
					if (response.data.permission) {
						this.setState({
							showLoader: false,
							permission: response.data.permission,
							editPermission: response.data.edit_permission,
							dataLoaded: true,
							reportReviewers: response.data.project_reviewers,
							usersList: response.data.users_list,
							reports: response.data.reports,
							selectedReport:
								response.data.reports && response.data.reports.id
								? response.data.reports.id
								: "",
						});
					} else {
						this.setState({
							showLoader: false,
							dataLoaded: true,
						});
					}
				}
			})
			.catch(function (error) {
				console.log("Error: " + error);
			});
	};

	onClose = () => {
		this.setState({
			popUpOpen: false,
			popUpAction: "",
			userId: 0,
			formValues: {},
			errors: {},
		});
	};

	onAdd = () => {
		this.setState({
			popUpOpen: true,
			popUpAction: "add",
			userId: 0,
		});
	};

	handleOnChange = (evt, value) => {
		let field = this.state.formValues;
		const name = evt.target.name;
		field[name] = evt.target.value;
		this.setState({
			formValues: field,
		});
	};

	deleteReportReviewer = (reportReviewerId, reportId, userId) => {
		let msg = "Do you want to delete this report reiewer?";
		this.setState({
			popUpOpen: true,
			popUpAction: "delete",
			confirmationMessage: msg,
			reportReviewerId: reportReviewerId,
			reportId: reportId,
			userId: userId
		});
	};

	addReportReviewer = (userId) => {
		this.setState({
			popUpOpen: true,
			popUpAction: "add",
			userId: userId,
			disableButton: false
		});
	};

	onConfirm = () => {
		let projectId = this.props.ProjectId;
		let userId = this.state.userId;
		if (this.state.popUpAction === "delete") {
			let reportId = this.state.reportId;
			let reportReviewerId = this.state.reportReviewerId;
			let apiEndpoint = "api/project/deleteReportReviewer";
			return httpServices
			.post(apiEndpoint, { project_id: projectId, report_reviewer_id: reportReviewerId, user_id: userId, report_id: reportId })
			.then((response) => {
				if (response.data) {
					let msg = "";
					let showmsg = false;
					if (response.data.status && response.data.message) {
						msg = response.data.message;
						showmsg = true;
					}
					if (response.data.permission) {
						this.setState(
								{
									popUpOpen: false,
									popUpAction: "",
									userId: 0,
									snackbarVariant : 'success',
									snackbarOpen : showmsg,
									snackbarMsg : msg,
								},
								() => this.getReportReviewers(projectId)
							);
						this.MixpanelManager.trackEvent("Project", {
							module: "Project",
							feature: "delete-location",
							action: "delete",
						});
					}
				}
			})
			.catch(function (error) {
				console.log("Error: " + error);
			});
		}
		if (this.state.popUpAction === "add") {
			let apiEndpoint = "api/project/saveProjectReviewer";
			if (this.validateFormData()) {
				this.setState({disableButton: true});
				let report_id = this.state.selectedReport;
				let user_id = this.state.formValues.user_id;
				return httpServices
				.post(apiEndpoint, {
					project_id: projectId,
					user_id: user_id,
					report_id: report_id,
				})
				.then((response) => {
					if (response.data) {
						let msg = "";
						let showmsg = false;
						if (response.data.status && response.data.message) {
							msg = response.data.message;
							showmsg = true;
						}
						if (response.data.permission) {
							this.setState(
								{
									popUpOpen: false,
									popUpAction: "",
									userId: 0,
									snackbarVariant : 'success',
									snackbarOpen : showmsg,
									snackbarMsg : msg,
									disableButton: false
								},
								() => this.getReportReviewers(projectId)
							);
							this.MixpanelManager.trackEvent("Project", {
								module: "Project",
								feature: "save-report-reviewer",
								action: "add"
							});
						}
					}
				})
				.catch(function (error) {
					console.log("Error: " + error);
				});
			}
		}
	};
	validateFormData = () => {
		let errors = {};
		let formValues = this.state.formValues;
		let valid = true;
		if (formValues.user_id === "undefined" || !formValues.user_id) {
			errors["user_id"] = "User Id cannot be empty";
			valid = false;
		}
		this.setState({
			errors: errors,
		});
		return valid;
	};

	snackbarClose = () => {
        this.setState({
            snackbarOpen: false,
        });
    }

	render() {
		return (
			<>
				<CustomProgressBar loaderOpen={this.state.showLoader} />
	
				{this.state.dataLoaded ? (
					<>
						{this.state.permission ? (
							<ReportReviewersComponent
								ReportReviewers={this.state.reportReviewers}
								ProjectLocations={this.state.projectLocations}
								EditPermission={this.state.editPermission}
								DeleteReportReviewer={this.deleteReportReviewer}
								AddReportReviewer={this.addReportReviewer}
								UsersList={this.state.usersList}
								Reports={this.state.reports}
								SelectedReport={this.state.selectedReport}
								Open={this.state.popUpOpen}
								Action={this.state.popUpAction}
								ConfirmationMessage={this.state.confirmationMessage}
								OnClose={this.onClose}
								OnConfirm={this.onConfirm}
								OnAdd={this.onAdd}
								FormValues={this.state.formValues}
								HandleOnChange={this.handleOnChange}
								Errors={this.state.errors}
								SnackbarOpen = {this.state.snackbarOpen}
								SnackbarVariant = {this.state.snackbarVariant}
								SnackbarMsg = {this.state.snackbarMsg}
								SnackbarClose={this.snackbarClose.bind(this)}
								DisableButton = {this.state.disableButton}
							/>
						) : (
							<></>
						)}
					</>
				) : (
					<></>
				)}
			</>
		);
	}
}
